const debug = true
const allList = ["af","sq","am","ar","hy","az","bn","bs","bg","ca","zh","zh-Hant","hr","cs","da","nl","et","en","fa","fil","fi","fr","ka","de","el","gu","ht","ha","he","hi","hu","is","id","ga","it","ja","kn","kk","ko","lv","lt","mk","ms","ml","mt","mr","mn","no","ps","pl","pt","pa","ro","ru","sr","si","sk","sl","so","es","sw","sv","ta","te","th","tr","uk","ur","uz","vi","cy", "sq"]

export default {
	debug: debug,
	home: debug ? "https://dev-www.englishpal.ai" : "https://www.englishpal.ai",
	domain: debug ? "https://dev-talk.englishpal.ai" : "https://talk.englishpal.ai",
	host: debug ? "https://dev-api.englishpal.ai/" : 'https://api.englishpal.ai/',
	package: 'calteacher',
	requestVersion: "2.2.0",
	platform: "web",
	version: '2.2.0',
	base: debug ? "https://d30wl21sck39q9.cloudfront.net/" : "https://d37vetb7rjh46y.cloudfront.net/",
	allList: allList,
	googleClientID: "963458844711-r02bpecno5us9pm70nn44omkekjcpfu9.apps.googleusercontent.com",
	appleClientID: "com.englishpal.web"
}
